import { render, staticRenderFns } from "./AttachUsergroupToMaingroup.vue?vue&type=template&id=2c25e6ef"
import script from "./AttachUsergroupToMaingroup.vue?vue&type=script&lang=js"
export * from "./AttachUsergroupToMaingroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports